export const formatObjectsToArrayOfIds = (
  items: Array<{ "@id": string } | string>,
) => items.map((item) => (typeof item === "object" ? item["@id"] : item));
